import * as moment from "moment";

export class DateWithinOneYear implements ng.IDirective {
  public restrict = 'A'; //attribute restrition
  public require = 'ngModel';

  public link = (scope: any, element: any, attrs: any, ngModelCtrl: any) => {
    $(() => {

      ngModelCtrl.$validators.dateWithinOneYear = function (modelValue, viewValue) {

        if (ngModelCtrl.$isEmpty(modelValue)) {
          return true;
        }

        if (modelValue < moment().subtract(1, 'years').toDate()) {
          return false;
        }

        return true;
      };
    });
  }
}

export class DateLessThanEqualToday implements ng.IDirective {
  public restrict = 'A';
  public require = 'ngModel';

  public link = (scope: any, element: any, attrs: any, ngModelCtrl: any) => {
    $(() => {

      ngModelCtrl.$validators.dateLessThanEqualToday = function (modelValue, viewValue) {
        if (ngModelCtrl.$isEmpty(modelValue)) {
            return true;
          }

          if (modelValue > moment().toDate()) {
            return false;
          }

          return true;
        };

    });
  }
};

export class DateCannotBeSame implements ng.IDirective {
  public restrict = 'A';
  public require = 'ngModel';

  public link = (scope: any, element: any, attrs: any, ngModelCtrl: any) => {
    $(() => {

      ngModelCtrl.$validators.dateCannotBeSame = function (modelValue, viewValue) {
        if (ngModelCtrl.$isEmpty(modelValue)) {
          return true;
        }

        var otherDate = moment(attrs.dateCannotBeSame, 'MM/dd/YYYY');

        if (moment(modelValue).isSame(otherDate)) {
          return false;
        }

        return true;
      };

    });
  }
};

